import Immutable from 'immutable';
import {
  deserializeIcons,
  deserializeNamesAndNumbers,
  isValidNameAndNumber
} from '~/data/deserializers/base';
import {isUpload} from '~/data/accessors/icon';
import {isNamesOrNumbers, isText} from '~/data/accessors/icon';

// The lab used to have some extra transformations for text that didn't exist downstream
// after removal text size is different so we make an attempt to resize to what it would used to be
// see https://3.basecamp.com/4443489/projects/17685263

const NEW_VERSION_DATE = '2020-08-20T18:30:00.000Z';
export function deserialize(data) {
  let rawIcons = getIcons(data);
  const olderDesign = new Date(data.updatedAt) < new Date(NEW_VERSION_DATE);
  rawIcons = rawIcons.map(icon => {
    const type = icon.type;
    if (olderDesign && (isNamesOrNumbers(type) || isText(type))) {
      icon.converted = false;
    }
    return icon;
  });
  const icons = deserializeIcons(rawIcons);
  return {
    ...data,
    design: deserializeDesign(data, icons, data.apiVersion),
    icons,
    namesAndNumbers: deserializeNamesAndNumbers(getNamesAndNumbers(data), data)
  };
}

export function hasInvalidUpload(data) {
  const icons = getIcons(data);
  const invalidIcons = icons.filter(icon => {
    return isUpload(icon.type) && icon.invalid;
  });
  return invalidIcons.length > 0;
}

function deserializeDesign(data, icons, apiVersion) {
  const {
    id,
    designId,
    designIdeaId,
    compositeId,
    designName,
    email,
    notes,
    canUpdate,
    inkMatches
  } = data;
  return Immutable.Map({
    apiVersion,
    clickedFromTheList: true,
    compositeId,
    email,
    fetching: false,
    designIdeaId,
    iconIds: icons.map(icon => icon.get('id')).toList(),
    designId,
    id,
    name: designName,
    canUpdate,
    isCombined: false,
    notes,
    inkMatches: Immutable.Map(inkMatches || {})
  });
}

export function getIcons(data) {
  return data.views.reduce((acc, view) => acc.concat(view.icons), []);
}

export function getNamesAndNumbers(data) {
  return data.personalization.filter(isValidNameAndNumber);
}
